import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary, #FFF9F2)' }}>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--text-secondary, #555)', fontSize: 14, marginBottom: 32
          }}
          data-testid="cookies-back-btn"
        >
          <ArrowLeft size={16} /> Terug naar Home
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <Cookie size={28} style={{ color: 'var(--accent-primary, #6366f1)' }} />
          <h1 style={{ fontSize: 32, fontWeight: 600, color: 'var(--text-primary, #232323)', margin: 0 }}>
            Cookiebeleid
          </h1>
        </div>

        <p style={{ color: 'var(--text-secondary, #555)', marginBottom: 8, fontSize: 14 }}>
          Laatst bijgewerkt: februari 2026
        </p>

        <div style={{ background: '#0E1620', borderRadius: 16, padding: '40px 36px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', lineHeight: 1.7, color: '#F4F7FB', fontSize: 15 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Wat zijn cookies?</h2>
          <p>Cookies zijn kleine tekstbestanden die door uw webbrowser op uw apparaat worden opgeslagen wanneer u onze website bezoekt. Ze helpen ons om uw voorkeuren te onthouden en uw ervaring te verbeteren.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Welke cookies gebruiken wij</h2>
          <p>Wij gebruiken de volgende typen cookies:</p>
          <ul>
            <li><strong>Essentieel:</strong> Noodzakelijk voor het functioneren van de website (authenticatie, taalvoorkeur)</li>
            <li><strong>Functioneel:</strong> Onthouden uw voorkeuren en instellingen</li>
            <li><strong>Analytisch:</strong> Helpen ons begrijpen hoe bezoekers de website gebruiken</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Cookies beheren</h2>
          <p>U kunt cookies beheren via de instellingen van uw webbrowser. Let op: het uitschakelen van essentiële cookies kan de functionaliteit van onze website beperken.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Cookies van derden</h2>
          <p>Wij kunnen diensten van derden gebruiken die cookies plaatsen. Wij hebben geen controle over deze cookies. Raadpleeg het privacybeleid van de betreffende derde partij voor meer informatie.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Contact</h2>
          <p>Voor vragen over ons cookiebeleid kunt u contact opnemen via:</p>
          <p style={{ fontWeight: 500 }}>E-mail: info@krypton9.com</p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
